export default (obj) => {
  let c = 0
  // eslint-disable-next-line
  for (let i in obj) {
    c++
  }
  return c
}



// WEBPACK FOOTER //
// ./src/utils/objectPropertiesCount.js